interface ConciergePillProps {
  hidden: boolean;
  onOpen: () => void;
}

export function ConciergePill({ hidden, onOpen }: ConciergePillProps) {
  if (hidden) return null;
  return (
    <button type="button" className="concierge-pill" onClick={onOpen}>
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M6 16.5 4 20l3.8-1.2A8 8 0 1 0 6 16.5Z" strokeLinejoin="round" />
      </svg>
      Concierge
    </button>
  );
}
